import { endpoint } from "../../../../../common/constant";
import { fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../../common/utils/methods/commonMethods/utilityMethod";

export const labelStyles = {
    color: "var(--Grey-Grey-90, #262626)",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
};

export const inputStyles = {
    height: "38px",
    borderRadius : "8px",
    border: "1px solid var(--Grey-30, #E2E2E2)"
};

export const fetchAdjustments = (psid, applicationDetails) => {
    const {psid : currPsid , termValue, applicationId} = applicationDetails;
    const url = `${endpoint.securityTransfer}?psid=${psid}&currentPsid=${currPsid}&term=${termValue}&currApplicationId=${applicationId}`;
    return fetchAllPromisedData(url, true);
}

export const applyAdjustment = (adjustmentDetails, applicationDetails, securityChargeDetails) => {
    const { 
        regularCourseId : oldRegularCourseId , 
        securityCourseId : oldSecurityCourseId, 
        businessAreaValue : oldBusinessAreaValue,
        applicationId : oldApplicationId,
        oldScholarshipTransactionId
    } = adjustmentDetails;

    const {
        applicationQuotationDetailsId : quotationId,
        applicationId : currApplicationId,
        termValue,
        businessAreaId : currBusinessAreaId,
        businessAreaValue : currBusinessAreaValue,
        courseId : currRegularCourseId,
        psid
    } = applicationDetails;

    const {
        id : otherChargesId,
        courseId : currSecurityCourseId
    } = securityChargeDetails;

    const req = {
        oldRegularCourseId,
        currRegularCourseId,
        oldSecurityCourseId,
        currSecurityCourseId,
        oldApplicationId,
        currApplicationId,
        oldBusinessAreaValue,
        currBusinessAreaValue,
        currBusinessAreaId,

        psid,
        otherChargesId,
        quotationId,
        oldScholarshipTransactionId,
        termValue
    }

    return fetchAllPostPromisedData(endpoint.securityTransfer, req);
}